export default __webpack_public_path__ + "static/media/stop.ac5ac6e1.svg";